import { CONSTANTS } from "../constants/constants";
import { IdentityProvider } from "../enums/identityProvider";
import ApplicationSettingService from "../services/applicationSettingService";

const DataService = {
    async baseUrl(): Promise<string> {
        try {
            return await ApplicationSettingService.getCarpeApiEndpoint(localStorage.getItem(CONSTANTS.user_region));
        } catch (error:any) {
            console.error('Error fetching API endpoint:', error.message);
            throw error;
        }
    },

    //Build authorization headers based on identity provider
    getAuthHeaders(): HeadersInit {
        const identityProvider = sessionStorage.getItem("IdentityProvider");
        const headers: HeadersInit = {
            'Content-Type': 'application/json'
        };
        
        if (identityProvider === IdentityProvider.PI) {
            //Platform Identity: Use dual token approach
            const platformToken = sessionStorage.getItem("PI-X-Auth-Token");
            const tcToken = sessionStorage.getItem("X-Auth-Token");
            
            if (platformToken && tcToken) {
                headers['Authorization'] = 'Bearer ' + platformToken;
                headers['TC-Token'] = tcToken;
            }
        } else {
            //IDS: Use single token
            const accessToken = sessionStorage.getItem("X-Auth-Token");
            
            if (accessToken) {
                headers['Authorization'] = 'Bearer ' + accessToken;
            }
        }
        
        return headers;
    },

    async fetchData<T>(url: string): Promise<T> {
        const apiUrl = await this.baseUrl() + url;
        const headers = this.getAuthHeaders();
        
        const response = await fetch(apiUrl, { headers });
        
        if (!response.ok || response.status === 204) {          
            throw new Error(response.statusText);
        }
  
        const data = await response.json();
        return data as T;
    },

    async postData<T>(url: string, obj: any): Promise<T> {
        const apiUrl = await this.baseUrl() + url;
        const headers = this.getAuthHeaders();

        const response = await fetch(apiUrl, {
            method: 'POST',
            body: JSON.stringify(obj),
            headers: headers
        });

        if (!response.ok) {
            throw new Error(response.statusText);
        }

        const result = await response.json();
        return result as T;
    }
}

export default DataService;